export default "__VITE_ASSET__C$kRTEJF__"